const replacerFunc = () => {
    const stack = [];
    return function (key, value) {
        if (typeof value === 'bigint') {
            return value.toString();
        }
        if (typeof value !== 'object' || value === null) {
            return value;
        }
        const stackIndex = stack.indexOf(this);
        if (stackIndex === -1) {
            stack.push(this);
        }
        else {
            stack.length = stackIndex + 1;
        }
        if (stack.includes(value)) {
            return '[Circular]';
        }
        return value;
    };
};
export function safeJsonStringify(obj, options = {}) {
    const { indent = 0, onError } = options;
    try {
        const result = JSON.stringify(obj, replacerFunc(), indent);
        return typeof result === 'string' ? result : '';
    }
    catch (error) {
        try {
            onError?.(error);
        }
        catch {
        }
        return '';
    }
}
